import React from 'react';
import PropTypes from 'prop-types';

import InternalLinking from './InternalLinking';

const getInternalLinkingContainer = pageName => {
  const InternalLinkingContainer = (props, { data }) => (
    <InternalLinking {...data[pageName].internalLinking} {...props} />
  );

  InternalLinkingContainer.contextTypes = {
    data: PropTypes.shape({
      [pageName]: PropTypes.shape({
        internalLinking: PropTypes.shape({
          countryCode: PropTypes.string.isRequired,
          areaSlug: PropTypes.string.isRequired,
          seoLinks: PropTypes.arrayOf(
            PropTypes.shape({
              anchorText: PropTypes.string.isRequired,
              url: PropTypes.string.isRequired
            })
          )
        })
      })
    })
  };

  return InternalLinkingContainer;
};

export default getInternalLinkingContainer;
